import { render, staticRenderFns } from "./ticketDetail.vue?vue&type=template&id=b3f047bc&lang=pug"
import script from "./ticketDetail.vue?vue&type=script&lang=js"
export * from "./ticketDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports